import React, {useEffect, useState} from "react";
import './transcription.scss';
import {isEmpty} from 'lodash';
import {getTranscription} from "./trascription.mapper";
import {Word} from "./components/word/Word";

export const Transcription = React.memo((props) => {
  const {transcription, onWordClicked, currentPlayerTime: playerTime} = props;
  const [phrases, setPhrases] = useState([]);

  useEffect(() => {
    setPhrases([])
    if (transcription && !isEmpty(transcription)) {
      const transcriptionPhrases = getTranscription(transcription);
      setPhrases(transcriptionPhrases);
    }

  }, [transcription])

  const isWordHighlight = (word, playerTime) => {
    if (word.startTime < playerTime) {
      if (word.endTime > playerTime) {
        return true
      }
    }
    return false
  };

  return (
    <div>
      {
        phrases.map((phrase) => {
          const {speaker, words} = phrase;
          return (
            <>
              {speaker.speakerName?.name && <div><span className="speaker">{speaker.speakerName.name}:</span></div>}
              {
                words.map(word => {
                  return (
                    <Word
                      key={word.startTime + word.length + word.word}
                      onWordClicked={onWordClicked}
                      highlight={isWordHighlight(word, playerTime)}
                      word={word}/>
                  )
                })
              }
              <div style={{marginTop: '10px'}}/>
            </>

          )
        })
      }
    </div>
  )
})

